import React from "react";
import { Col, Row } from "reactstrap";
import CheckboxField from "src/components/Form/CheckboxFieldV2/CheckboxFieldV2";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import * as S from "src/constants/StringConstants";

const DISCOUNT_FIELDS = [
  { name: "mdsaDiscount", label: S.APP_FIELD_MDSA_LABEL },
  { name: "eApplyDiscount", label: S.APP_FIELD_E_APPLY_LABEL },
  { name: "multiLifeDiscount", label: S.APP_FIELD_MULTI_LIFE_LABEL, percentage: "multiLifeDiscountPercentage" },
  { name: "preferredOccDiscount", label: S.APP_FIELD_PREFERRED_OCC_LABEL },
  { name: "businessOwnerDiscount", label: S.APP_FIELD_BUSINESS_OWNER_LABEL },
  { name: "residencyDiscount", label: S.APP_FIELD_RESIDENCY_LABEL, percentage: "residencyDiscountPercentage" },
  { name: "multiProductDiscount", label: S.APP_FIELD_MULTI_PRODUCT_LABEL },
  { name: "spousalDiscount", label: S.APP_FIELD_SPOUSAL_LABEL },
  {
    name: "associationOrAffiliationDiscount",
    label: S.APP_FIELD_ASSOCIATION_LABEL,
    percentage: "associationOrAffiliationDiscountPercentage",
  },
  { name: "gsiDiscount", label: S.APP_FIELD_GSI_LABEL, percentage: "gsiDiscountPercentage" },
  { name: "otherDiscount", label: S.APP_FIELD_OTHER_LABEL, percentage: "otherDiscountPercentage" },
];

const DiscountsForm = () => {
  return (
    <Col sm="4">
      <Row>
        <Col sm="10" className="app-form-header">
          <h4 className="form-title">{S.APP_DISCOUNTS_TITLE}</h4>
        </Col>
      </Row>

      <Row className="app-checkbox-container">
        {DISCOUNT_FIELDS.map(({ name, label, percentage }) => (
          <Row key={name} className="app-checkbox-form-row">
            <Col sm="12" className={`app-form-checkbox-label-container${percentage ? "__text-field" : ""}`}>
              <Col sm="6">
                <CheckboxField name={name} label={label} />
              </Col>

              {percentage && (
                <Col sm="4">
                  <TextField name={percentage} />
                </Col>
              )}
            </Col>
          </Row>
        ))}
      </Row>
    </Col>
  );
};

export default DiscountsForm;
